<template>
  <div class="innerItem">
    <p class="innerTitle setLabel">{{locale.mobility}}</p>
    <div>
      <div class="checkbox mb15">
        <input type="checkbox" id="mobility_preset" v-model="mobility.activePreset">
        <label for="mobility_preset" class="label">{{ locale.mobility_destination_preset_active }}</label>
      </div>
      <div v-if="mobility.activePreset">
        <button type="button" class="btn btnWhite" @click.stop="editPreset">{{ locale.mobility_destination_preset_setting }}</button>
      </div>
    </div>
    <EditPreset
      v-if="editLayer"
      :locale="locale"
      :presetList="mobility.preset"
      @apply="applyPreset"
      @cancel="cancelEdit" />
  </div>
</template>

<script>
import EditPreset from './MobilityPresetEdit.vue'

export default {
  name: 'Mobility',
  props: [
    'locale',
    'mobility'
  ],
  components: {
    EditPreset
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
      editLayer: false
    }
  },
  methods: {
    editPreset () {
      this.editLayer = true
    },
    applyPreset (data) {
      this.mobility.preset = data
      this.editLayer = false
    },
    cancelEdit () {
      this.editLayer = false
    }
  }
}
</script>

<style lang="scss" scoped>
.presetItem {
  position: relative;
  margin-top: 10px;
  padding: 10px 45px 10px 15px;
  font-size: 18px;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
  cursor: pointer;
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 100%;
    background: url('~@/assets/img/ico_close_black.svg') 50% 6px / 12px no-repeat;
    opacity: 0.5;
  }
  & + .presetItem {
    margin-top: 5px;
  }
}
</style>./MobilityPresetItem.vue
